//Prevent Multiple Hits (Hit as per Routes)
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import Layouts from "../../layouts/layouts";
import Swal from "sweetalert2";

import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
  useMap,
  Circle,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const routeColors = ["#FF0000", "#0000FF", "#008000", "#800080", "#FFA500"];
const vehicleColor = ["#FF0000", "#0000FF", "#008000", "#800080", "#FFA500"];

export default function MyMapComponentOrderView() {
  const markerRef = useRef(null);
  const [startingPoint, setStartingPoint] = useState([30.7076636, 76.6855201]); // Default coordinates

  const navigate = useNavigate();
  const location = useLocation();

  const { id } = useParams();
  const [routeData, setRouteData] = useState([]);
  const [vehicleCount, setVehicleCount] = useState(1);
  const [routes, setRoutes] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const [users, setUsers] = useState([]);
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [routeAssignments, setRouteAssignments] = useState([]);
  const selectedClientObj = clients.find(
    (client) => client._id === selectedClient
  );
  const existingapistate = location.state?.apistate || {}; // Retrieve previous order data
  const [apistate, setApiState] = useState([]);
  const [noDataMessage, setNoDataMessage] = useState("");

  const [routeSelections, setRouteSelections] = useState({});
  const today = new Date().toISOString().split("T")[0];

  const [selectedDate, setSelectedDate] = useState(today);

  const ORS_API_KEY =
    "5b3ce3597851110001cf6248350951574cfd4d67bdf15c2608a63e91";

  useEffect(() => {
    fetchClients();
  }, []);

  useEffect(() => {
    console.log("Updated Routes:", routes);
  }, [routes]);

  const ORSRouting = ({ waypoints = [], color = "blue" }) => {
    const [routeCoords, setRouteCoords] = useState([]);
    const map = useMap();
    useEffect(() => {
      const fetchORSRoute = async () => {
        if (!map) return;
        if (waypoints.length < 2) return;

        try {
          const coords = waypoints.map((wp) =>
            Array.isArray(wp) ? [wp[1], wp[0]] : [wp.lng, wp.lat]
          );

          const response = await axios.post(
            "https://api.openrouteservice.org/v2/directions/driving-car/geojson",
            {
              coordinates: coords,
            },
            {
              headers: {
                Authorization: ORS_API_KEY,
                "Content-Type": "application/json",
              },
            }
          );

          const geometry = response.data.features[0].geometry;
          const leafletCoords = geometry.coordinates.map((coord) => [
            coord[1],
            coord[0],
          ]);

          setRouteCoords(leafletCoords);

          // 🛑 SAFETY: Delay to ensure map is visible & mounted before fitting
          setTimeout(() => {
            if (leafletCoords.length > 0 && map && map.fitBounds) {
              try {
                map.fitBounds(leafletCoords);
              } catch (err) {
                console.warn("💥 fitBounds failed:", err);
              }
            }
          }, 300); // tweak delay if needed
        } catch (error) {
          console.error("ORS route fetch error:", error);
        }
      };

      fetchORSRoute();
    }, [waypoints, map]);

    return routeCoords.length ? (
      <Polyline positions={routeCoords} color={color} weight={4} />
    ) : null;
  };
  const addressMap = new Map();

  const fetchClients = async () => {
    try {
      const token = localStorage.getItem("token");
      const userRole = localStorage.getItem("userRole");

      if (!token || !userRole) {
        console.error("No token or user role found");
        return;
      }

      let apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/clients`;

      if (userRole === "admin") {
        apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/clients`;
      } else if (userRole === "clientmanager") {
        apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/clients`;
      }

      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const fetchedClients = response.data.clients || [];

      console.log("Clients fetched:", fetchedClients);
      setClients(fetchedClients);
      if (fetchedClients.length === 1) {
        const onlyClient = {
          value: fetchedClients[0]._id,
          label: fetchedClients[0].name,
        };
        setSelectedClient(onlyClient);
        handleClientChange(onlyClient); // if you also want to fetch data
      }
    } catch (error) {
      console.error("Error fetching clients:", error);
      setClients([]);
    }
  };

  const getEstimatedTime = async (waypoints) => {
    const apiKey = ORS_API_KEY;
    const url = "https://api.openrouteservice.org/v2/directions/driving-car";

    const coordinates = waypoints.map(([lat, lng]) => [lng, lat]);

    try {
      const response = await axios.post(
        url,
        { coordinates },
        {
          headers: {
            Authorization: apiKey,
            "Content-Type": "application/json",
          },
        }
      );

      const durationInSeconds = response.data.routes[0].summary.duration;
      const durationInMinutes = Math.ceil(durationInSeconds / 60);
      return `${durationInMinutes} mins`;
    } catch (error) {
      console.error("Error getting segment time:", error);
      return "N/A";
    }
  };

  const fetchData = async (selectedDate = "", clientId = "") => {
    try {
      const token = localStorage.getItem("token");
      const userRole = localStorage.getItem("userRole");

      if (!token) {
        console.error("❌ No token found, exiting fetchData()");
        return;
      }

      // Build API URL
      let apiUrl;
      if (userRole === "superadmin") {
        apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v3/superadmin/order-routes`;
      } else if (userRole === "admin") {
        apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v3/admin/order-routes`;
      } else if (userRole === "clientmanager") {
        apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v3/clientmanager/order-routes`;
      } else {
        console.error("❌ Unauthorized role:", userRole);
        return;
      }

      const params = new URLSearchParams();
      if (selectedDate) {
        params.append("delivery_date", selectedDate);
      }
      if (clientId) {
        params.append("client_id", clientId);
      }

      const finalUrl = `${apiUrl}?${params.toString()}`;

      const response = await axios.get(finalUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (Array.isArray(response.data.routes)) {
        const formattedRoutes = await Promise.all(
          response.data.routes.map(async (route) => {
            const waypoints = [
              route.hub_id?.coordinates
                ? [
                    route.hub_id.coordinates.latitude,
                    route.hub_id.coordinates.longitude,
                  ]
                : null,
              ...route.order
                .filter((o) => o.order_id?.delivery_address)
                .map((o) => [
                  o.order_id.delivery_address.lat,
                  o.order_id.delivery_address.lng,
                ]),
            ].filter(Boolean); // remove nulls

            let totalEstimatedTime = "N/A";
            let totalEstimatedDistance = "N/A";

            if (waypoints.length > 1) {
              try {
                const coordinates = waypoints.map(([lat, lng]) => [lng, lat]);

                const orsRes = await axios.post(
                  "https://api.openrouteservice.org/v2/directions/driving-car/geojson",
                  { coordinates },
                  {
                    headers: {
                      Authorization: ORS_API_KEY, // Make sure this is in your .env
                      "Content-Type": "application/json",
                    },
                  }
                );

                const summary = orsRes.data.features[0].properties.summary;

                // Distance
                const distanceMeters = summary.distance;
                totalEstimatedDistance = `${(distanceMeters / 1000).toFixed(
                  2
                )} km`;

                // Time
                const durationSec = summary.duration;
                const totalMinutes = Math.round(durationSec / 60);
                const hours = Math.floor(totalMinutes / 60);
                const minutes = totalMinutes % 60;

                totalEstimatedTime =
                  hours > 0
                    ? `${hours} hr${hours > 1 ? "s" : ""} ${minutes} min${
                        minutes !== 1 ? "s" : ""
                      }`
                    : `${minutes} min${minutes !== 1 ? "s" : ""}`;
              } catch (err) {
                console.error("ORS routing error:", err);
              }
            }

            return {
              routeId: route._id,
              routeName: route.route_name,
              client: route.client_id?.name || "N/A",
              clientId: route.client_id?._id || null,
              hub: route.hub_id?.name || "N/A",
              startingPoint: route.hub_id?.coordinates
                ? [
                    route.hub_id.coordinates.latitude,
                    route.hub_id.coordinates.longitude,
                  ]
                : null,
              driver: route.driver_id ? `${route.driver_id.name} ` : "N/A",
              da: route.daUserId ? `${route.daUserId.name}` : "N/A",
              vehicle: route.vehicle_id
                ? `${route.vehicle_id.numberplate}`
                : "N/A",
              deliveryDate: new Date(route.delivery_date).toLocaleDateString(),
              totalOrders: route.totalOrders,
              pendingOrders: route.pendingOrders,
              deliveredOrders: route.deliveredOrders,
              cancelledOrders: route.cancelledOrders,
              estimatedTime: totalEstimatedTime,
              estimatedDistance: totalEstimatedDistance, // ✅ added distance
              orders: route.order.map((order) => ({
                sequence: order.sequence_number,
                orderId: order.order_id._id,
                status: order.order_id.order_status,
                customer: order.order_id.customer_detail.customer_name,
                phone: order.order_id.customer_detail.customer_phone,
                address: order.order_id.address,
                location: order.order_id.delivery_address,
              })),
            };
          })
        );

        setRoutes(formattedRoutes);
        setApiState(formattedRoutes);

        if (formattedRoutes.length === 0) {
          setNoDataMessage("No order routes found for the selected filters.");
        } else {
          setNoDataMessage("");
        }

        setRouteAssignments();
      } else {
        console.error("❌ Unexpected data format from API", response.data);
      }
    } catch (error) {
      console.error("❌ Error fetching data:", error);
      setNoDataMessage("No order routes found for the selected filters.");
      setRoutes([]);
      setApiState([]);
    }
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  // const handleClientChange = (selectedOption) => {
  //   setSelectedClient(selectedOption?.value || null);
  // };
  const handleClientChange = (selectedOption) => {
    setSelectedClient(selectedOption); // ✅ set selected value in state
    // You can call fetchData() or update formData as needed
  };

  const handleFetchRoutes = () => {
    if (!selectedDate || !selectedClient) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please select both Delivery Date and Client before fetching routes.",
      });
      return;
    }

    fetchData(selectedDate, selectedClient.value);
  };
  return (
    <>
      <Layouts />
      <div className="card-body">
        <div className="row justify-content-center">
          <div className="d-flex align-items-center justify-content-between w-100">
            <div className="me-3">
              <label>
                <b style={{ color: "red" }}> SELECT DATE : </b>
                <input
                  type="date"
                  value={selectedDate}
                  onChange={handleDateChange} // ✅ Call function on change
                  style={{ marginLeft: "10px" }}
                />
              </label>
            </div>
            <div className="me-3">
              <label>
                <b style={{ color: "red" }}> SELECT CLIENT : </b>

                <Select
                  value={selectedClient}
                  options={clients.map((client) => ({
                    value: client._id,
                    label: client.name,
                  }))}
                  onChange={handleClientChange}
                  classNamePrefix="select"
                />
              </label>
            </div>
            <button
              className="btn btn-primary ms-3"
              onClick={handleFetchRoutes}
            >
              Fetch Routes
            </button>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row">
          <div
            className="col-md-3 bg-light p-3"
            style={{ height: "86vh", overflowY: "auto" }}
          >
            <h3 className="mb-3">Route Details</h3>

            {routes.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  marginTop: "2rem",
                  color: "red",
                  fontWeight: "bold",
                }}
              >
                NO ROUTE FOUND YET
              </div>
            ) : (
              routes.map((route, index) => {
                const routeName = route.routeName || `Route ${index + 1}`;

                const addresses =
                  route.orders?.map((order) => order.address) || [];

                return (
                  <div key={index} className="p-3 mb-3 rounded shadow-sm">
                    <h6
                      className="p-2 text-center"
                      style={{
                        backgroundColor:
                          vehicleColor[index % vehicleColor.length],
                        color: "#fff",
                        borderRadius: "5px",
                      }}
                    >
                      {routeName}
                    </h6>
                    <br />
                    {/* All your details inside */}
                    <p>
                      <strong>Total Orders :</strong> {route.totalOrders}
                    </p>
                    <p>
                      <strong>Delivered Orders:</strong> {route.deliveredOrders}{" "}
                      <img
                        src="/marker-icon-green.png"
                        alt="Delivered"
                        style={{
                          width: "16px",
                          height: "25px",
                          marginLeft: "6px",
                          verticalAlign: "middle",
                        }}
                      />
                    </p>
                    <p>
                      <strong>Pending Orders:</strong> {route.pendingOrders}{" "}
                      <img
                        src="/marker-icon-red.png"
                        alt="Pending"
                        style={{
                          width: "16px",
                          height: "25px",
                          marginLeft: "6px",
                          verticalAlign: "middle",
                        }}
                      />
                    </p>
                    <p>
                      <strong>Cancelled Orders :</strong>{" "}
                      {route.cancelledOrders}
                    </p>
                    <p>
                      <strong>Vehicle Assigned:</strong>{" "}
                      {route.vehicle || "Not Assigned"}
                    </p>
                    <p>
                      <strong>Driver Assigned :</strong>{" "}
                      {route.driver || "Not Assigned"}
                    </p>
                    <p>
                      <strong>DA Assigned:</strong> {route.da || "Not Assigned"}
                    </p>
                    <p>
                      <strong>Estimated Time :</strong> {route.estimatedTime}
                    </p>
                    <p>
                      <strong>Estimated KM :</strong> {route.estimatedDistance}
                    </p>

                    <ul className="mt-2 ps-3">
                      {route.orders?.map((order, i) => (
                        <li
                          key={i}
                          className="py-1 d-flex align-items-center gap-2"
                        >
                          <span
                            style={{
                              color: vehicleColor[index % vehicleColor.length],
                              fontWeight: "bold",
                              marginRight: "5px",
                            }}
                          >
                            {i + 1}.
                          </span>
                          <span>{order.address || "Unknown Address"}</span>
                          <span className="ms-2">
                            {order.status === "Delivered" ? (
                              <span className="text-success">✅</span>
                            ) : (
                              <span className="text-danger">❌</span>
                            )}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })
            )}
          </div>

          <div className="col-md-9">
            <MapContainer
              center={startingPoint}
              zoom={12}
              style={{ width: "100%", height: "86vh" }}
            >
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

              {/* Routes */}
              {routes.map((route, index) => {
                if (!route.startingPoint) return null; // Skip if no starting point

                const waypoints = [
                  route.startingPoint,
                  ...route.orders
                    .filter(
                      (order) => order.location?.lat && order.location?.lng
                    )
                    .map((order) => [order.location.lat, order.location.lng]),
                ];
                const [lat, lng] = route.startingPoint;
                return (
                  <React.Fragment key={`hub-${index}`}>
                    <Marker
                      position={[lat, lng]}
                      icon={L.icon({
                        iconUrl: "/warehouse.png",
                        iconSize: [32, 32],
                      })}
                    >
                      <Popup>
                        <strong>Hub: {route.hub}</strong>
                        <p>{route.hub}</p>
                      </Popup>
                    </Marker>

                    {/* Geofence Circle */}
                    <Circle
                      center={[lat, lng]}
                      radius={1000} // in meters
                      pathOptions={{
                        stroke: false, // 👈 disables the border entirely
                        fillColor: "#3f9df4", // or any blue shade you like
                        fillOpacity: 0.2, // slightly transparent fill
                      }}
                    />

                    {/* Route Path */}
                    <ORSRouting
                      waypoints={waypoints}
                      color={routeColors[index % routeColors.length]}
                    />

                    {/* Hub Marker */}
                    <Marker position={route.startingPoint}>
                      <Popup>Hub: {route.hub}</Popup>
                    </Marker>

                    {/* Geofence Circle */}
                    <Circle
                      center={route.startingPoint}
                      radius={1000} // Radius in meters
                      pathOptions={{
                        stroke: false,
                        fillColor: "#3f9df4",
                        fillOpacity: 0.2,
                      }}
                    />
                  </React.Fragment>
                );
              })}

              {/* Order Markers */}
              {routes.flatMap((route) =>
                route.orders.map((order, i) => {
                  if (!order.location?.lat || !order.location?.lng) return null; // Skip invalid orders

                  const iconUrl =
                    order.status === "Delivered"
                      ? "/marker-icon-green.png"
                      : "/marker-icon-red.png";

                  const customIcon = L.icon({
                    iconUrl,
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    shadowUrl:
                      "https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png",
                  });

                  return (
                    <Marker
                      key={`order-${i}`}
                      position={[order.location.lat, order.location.lng]}
                      icon={customIcon}
                    >
                      <Popup>
                        <strong>Order {i + 1}</strong>
                        <p>{order.address || "Unknown"}</p>
                        <p
                          style={{
                            color:
                              order.status === "Delivered" ? "green" : "red",
                          }}
                        >
                          {order.status}
                        </p>
                      </Popup>
                    </Marker>
                  );
                })
              )}
            </MapContainer>
          </div>
        </div>
      </div>
    </>
  );
}
